document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('subscribe-popup');
  const closeBtn = popup.querySelector('.subscribe-popup-close');

  // Don't show if popup was already closed
  if (localStorage.getItem('popupClosed') === 'true') return;

  // Show popup after 35 seconds
  setTimeout(() => {
    popup.classList.add('active');
  }, 35000);

  // Close popup
  closeBtn.addEventListener('click', () => {
    popup.classList.remove('active');
    localStorage.setItem('popupClosed', 'true'); // won't show again
  });
});